export const LANGUAGE_CODE = 'ja-JP';
export const MARKET_CODE = 'JPN';
export const CURRENCY_CODE = 'JPY';
export const YAKKAN_URL = 'https://travel.rakuten.co.jp/info/yakkan/tehai.html';
export const SITE_IMAGE_URL =
  'https://img.travel.rakuten.co.jp/share/common/images/bnr_ogp_logo.gif';
